module.exports = __webpack_public_path__ + "static/media/p2008mot4.fc404c28.jpg";